import { Toaster } from "sonner";
import PoweredByLumetier from "@/components/PoweredByLumetier";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Outermost page chrome — keeps the gallery routes visually distinct from the marketing
// site (no nav/footer) so clients land on the editorial photo experience immediately.
export default function Shell({ children, cover, hero }) {
  return (
    <div className="min-h-screen bg-stone-50 text-stone-900 pb-24">
      <Toaster richColors position="top-center" />
      {hero ? (
        <div className="w-full h-72 sm:h-[420px] md:h-[520px] overflow-hidden">{hero}</div>
      ) : cover ? (
        <div className="w-full h-44 sm:h-64 overflow-hidden bg-stone-200">
          <img
            src={cover.startsWith("http") ? cover : `${BACKEND}${cover}`}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ) : null}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">{children}</div>
      <PoweredByLumetier variant="light" />
    </div>
  );
}

// Lightweight labeled text input shared by the submit modal. Lives here so any other
// gallery sub-component can reach for it without re-implementing the underline style.
export function In({ label, value, onChange, type = "text", testid }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-[0.18em] text-stone-500">{label}</span>
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full bg-transparent border-b border-stone-300 py-2 outline-none focus:border-stone-900 text-sm"
        data-testid={testid}
      />
    </label>
  );
}
